import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import App from './App';
import { ThemeSync } from './components/theme/ThemeSync';
import './styles/globals.css';
import { PerformanceProvider } from './services/performance.service';
import { initTheme } from './theme/theme';
import { UIModeProvider } from './context/UIModeContext';

initTheme();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5,
      retry: 1,
    },
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <PerformanceProvider>
          <UIModeProvider>
            <App />
            <ThemeSync />
          </UIModeProvider>
        </PerformanceProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
);